import { User } from 'Types';

export type UserData = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  isActive: boolean;
};

export const formatUserList = (users: User[]): UserData[] => {
  return users.map(({ id, email, firstName, lastName, isActive, company }) => ({
    id,
    email,
    firstName,
    lastName,
    company: company.name,
    isActive,
  }));
};
